// #region module
export const DEFAULT_SERVER_PORT = process.env.PORT
    ? parseInt(process.env.PORT)
    : 8080;


export const DEFAULT_SERVER_OPTIONS_SERVER_NAME = 'Plurid Server';
export const DEFAULT_SERVER_OPTIONS_HOSTNAME = 'origin';
export const DEFAULT_SERVER_OPTIONS_QUIET = false;
export const DEFAULT_SERVER_OPTIONS_COMPRESSION = true;
export const DEFAULT_SERVER_OPTIONS_OPEN = false;
export const DEFAULT_SERVER_OPTIONS_BUILD_DIRECTORY = 'build';
export const DEFAULT_SERVER_OPTIONS_ASSETS_DIRECTORY = 'assets';
export const DEFAULT_SERVER_OPTIONS_STILLS_DIRECTORY = 'stills';
export const DEFAULT_SERVER_OPTIONS_GATEWAY = '/gateway';

export const DEFAULT_SERVER_OPTIONS = {
    SERVER_NAME: DEFAULT_SERVER_OPTIONS_SERVER_NAME,
    HOSTNAME: DEFAULT_SERVER_OPTIONS_HOSTNAME,
    QUIET: DEFAULT_SERVER_OPTIONS_QUIET,
    COMPRESSION: DEFAULT_SERVER_OPTIONS_COMPRESSION,
    OPEN: DEFAULT_SERVER_OPTIONS_OPEN,
    BUILD_DIRECTORY: DEFAULT_SERVER_OPTIONS_BUILD_DIRECTORY,
    ASSETS_DIRECTORY: DEFAULT_SERVER_OPTIONS_ASSETS_DIRECTORY,
    STILLS_DIRECTORY: DEFAULT_SERVER_OPTIONS_STILLS_DIRECTORY,
    GATEWAY: DEFAULT_SERVER_OPTIONS_GATEWAY,
};


export const DEFAULT_RENDERER_LANGUAGE = 'en';
export const DEFAULT_RENDERER_ROOT = 'root';
export const DEFAULT_RENDERER_PLURID_STATE = '{}';
export const DEFAULT_RENDERER_VENDOR_SCRIPT_SOURCE = '/vendor.js';
export const DEFAULT_RENDERER_MAIN_SCRIPT_SOURCE = '/index.js';
export const DEFAULT__PRELOADED_PLURID_METASTATE__ = '__PRELOADED_PLURID_METASTATE__';


// String sentinel meaning "all routes" — used to match a catch-all `preserve` (`preserve.serve === '*'`).
export const CATCH_ALL_ROUTE = '*';
// The Express route PATTERN for the catch-all GET. A RegExp (not the bare `'*'` string) so it works under
// Express 5 / path-to-regexp v8, where unnamed string wildcards are no longer valid.
export const CATCH_ALL_ROUTE_PATTERN = /.*/;
export const NOT_FOUND_ROUTE = process.env.PLURID_SERVER_NOT_FOUND_ROUTE || '/not-found';
export const PTTP_ROUTE = process.env.PLURID_SERVER_PTTP_ROUTE || '/pttp';



export const environment = {
    production: process.env.ENV_MODE === 'production',
    development: process.env.ENV_MODE === 'development',
};
// #endregion module
